module.exports = __webpack_public_path__ + "static/media/tutorial-treasure-augment.616c3224.gif";